import Vue from 'vue'
const globalData = new Vue({
  data: {
    USERRIGHT: [],
    COMPANYDATA: []
  }
})
Vue.mixin({
  methods: {
    $checkRight (right) {
      let flag = false
      right.map((val) => {
        if (globalData.$data.USERRIGHT.indexOf(val) > -1) {
          flag = true
          return false
        }
      })
      return flag
    },
    $saveRight (rights) {
      globalData.$data.USERRIGHT = rights
    },
    $getCompanyData () {
      return globalData.$data.COMPANYDATA
    },
    $saveCompanyData (company) {
      globalData.$data.COMPANYDATA = company
    },
  },
  data: function () {
    return {
    }
  }
})
// Date Formating
Vue.filter('formatDate', function (value) {
  return value ? value.split('-').reverse().join('-') : ''
})
export default globalData
